import { type FC, type HTMLAttributes, useState, useCallback } from "react";
import { Button } from "@wbly/ui/components/Button";
import type { KeyTextField } from "@prismicio/client";
import styles from "./ContentCard.module.css";

export type CopyCodeButtonProps = {
  discountCode?: KeyTextField;
  ctaCodeCopied?: KeyTextField;
  ctaText?: KeyTextField;
} & HTMLAttributes<HTMLElement>;

const { button } = styles;

export const CopyCodeButton: FC<CopyCodeButtonProps> = (props) => {
  const { ctaCodeCopied, ctaText, discountCode } = props;

  const [isCopied, setIsCopied] = useState(false);
  const copyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(discountCode);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000); // Reset after 2 seconds
  }, [discountCode]);

  return (
    <Button className={button} fullWidth={true} onClick={copyToClipboard}>
      {isCopied ? ctaCodeCopied : `${ctaText} ${discountCode}`}
    </Button>
  );
};

export default CopyCodeButton;
